import React, {useState} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import axios from './axiosConfig';

const ResetPasswordPage = () => {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const {token} = useParams();
    const navigate = useNavigate();

    const handleSubmit = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            setError('Passwords do not match.');
            return;
        }

        try {
            const response = await axios.post('/api/reset-password/' + token, {newPassword});
            if (response.status === 200) {
                navigate('/login');  // 密码重置成功后跳转到登录页面
            } else {
                setError('Failed to reset password. Please try again.');
            }
        } catch (error) {
            setError('Failed to reset password. Please try again.');
        }
    };

    return (
        <div>
            <h2>Reset Your Password</h2>
            <form onSubmit={handleSubmit}>
                <label>New Password:</label>
                <input
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    required
                />
                <label>Confirm Password:</label>
                <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                />
                <button type="submit">Reset Password</button>
                {error && <p>{error}</p>}
            </form>
        </div>
    );
};

export default ResetPasswordPage;
